import React, { Component } from 'react';
import axios from 'axios';
import spinner from '../../images/loading-spinner.gif';
import { translate } from 'react-i18next';

let cancelToken;
let disabled = true
class FormUser extends Component{

    constructor(props) {
        super(props);
        this.state ={
            sendPost: false,
            objCitites: {}
        }
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
        if (this.props.info.centro_id < 1) {
            this.getCities()
        }
    }

    getCities = () => {
        let params = {token_id: this.props.getTokenId}
        this.props.post(
            "/improvement/getCities", params, (response) => this.handleSuccesCities(response), (error) => this.handleErrorCities(error), cancelToken
        );
    }

    handleSuccesCities = (response) => {
        this.setState({objCitites: response})
    }
    handleErrorCities = (codeError, param_uno, param_dos, msgError) => { this.setState({objCitites: {}}) }

    handleClickContinue = (event) => {
        if (this.props.info.centro_id > 0 && this.props.info.ciudad_id > 0 && this.props.info.socio) {
            this.setState({sendPost: true})    
        }
    }

    render() {
        return(
            <div>
                <form id="form_user" method="post" onSubmit={this.props.handleSubmitUser}>
                    <div className="form-group">
                        {this.email()}
                    </div>
                    <div className="form-group">
                        {this.socio()}
                    </div>
                    <div className="form-group">
                        {this.empresa()}
                    </div>
                    <div className="form-group">
                        {this.telefono()}
                        {this.oficina()}
                    </div>
                    <div className="form-group">
                        {this.ciudad()}
                    </div>
                    <div className="form-group">
                        {(this.props.info.ciudad_id) ? this.centro() : ''}
                    </div>
                    <div className="form-group">
                        {this.formButton()}
                        <center> <p className="message-warning">{this.props.info.errorPoll}</p> </center>
                    </div>
                </form>
            </div>
        );
    }

    email = () => {
        return (
            <div className="col-md-12">
                <h3 className="info_socio" style={{fontSize: 'large', fontWeight: 'bold'}}>{this.props.info.email}</h3>
            </div>
        )
    }

    socio = () => {
        const { t } = this.props;
        if (this.props.info.socio && this.props.info.objUser.socio) {
            return (
                <div className="col-md-12">
                    <h3 className="info_socio">{this.props.info.socio}</h3>
                </div>
            )
        } else {
            return (
                <div className="col-md-12">
                    <label htmlFor="socio">{t('dashboard.question.data.fullname')}<i>*</i></label>
                    <input className="form-control" name="socio" placeholder="Nombre" type="text" onChange={this.props.handleInputChange} />
                </div>
            )
        }
    }

    empresa = () => {
        const { t } = this.props;
        if (this.props.info.empresa && this.props.info.objUser.empresa) {
            return (
                <div className="col-md-12">
                    <h3 className="info_socio">{this.props.info.empresa}</h3>
                </div>
            )
        } else {
            return (
                <div className="col-md-12">
                    <label htmlFor="empresa">{t('dashboard.question.data.office')}</label>
                    <input className="form-control" name="empresa" placeholder="IOS OFFICES" type="text" onChange={this.props.handleInputChange} />
                </div>
            )
        }
    }

    telefono = () => {
        const { t } = this.props;
        if (this.props.info.telefono && this.props.info.objUser.telefono) {
            return (
                <div className="col-md-8">
                    <h3 className="info_socio">{this.props.info.telefono}</h3>
                </div>
            )
        } else {
            return (
                <div className="col-md-8">
                    <label htmlFor="telefono">{t('dashboard.question.data.phone')}</label>
                    <input className="form-control" name="telefono" placeholder="8117209477" type="text" onChange={this.props.handleInputChange} />
                </div>
            )
        }
    }

    oficina = () => {
        const { t } = this.props;
        if (this.props.info.suite && this.props.info.objUser.oficina) {
            return (
                <div className="col-md-4">
                    <h3 className="info_socio">{this.props.info.suite}</h3>
                </div>
            )
        } else {
            return (
                <div className="col-md-4">
                    <label htmlFor="suite">{t('dashboard.question.data.suite')}</label>
                    <input className="form-control" name="suite" placeholder="SUITE 101" type="text" onChange={this.props.handleInputChange} />
                </div>
            )
        }
    }


    ciudad = () => {
        const { t } = this.props;
        if (this.props.info.objUser.ciudad) {
            return (
                <div className="col-md-8">
                    <h3 className="info_socio">{this.props.info.ciudad}</h3>
                </div>
            )
        } else {
            return (
                <div className="col-md-12">
                    <label htmlFor="ciudad">{t('dashboard.question.data.city')}<i>*</i></label>
                    {this.optionsCities()}
                </div>
            )
        }
    }

    // Select ciudades
    optionsCities = () => {
        const { t } = this.props;
        if (Object.keys(this.state.objCitites).length > 0) {
            return (
                <select className="form-control" id="ciduad_id" name="ciduad_id" required onChange={this.props.handleInputChangeCity}>
                    <option value="" selected disabled>{t('dashboard.question.botooms.select')}</option>    
                    {Object.values(this.state.objCitites).map((ciudad, i) => (
                        <option key={i} value={ciudad.id}>{ciudad.ciudad}</option>
                    ))}
                </select>
            )
        } else {
            return (
                <select className="form-control" id="ciduad_id" name="ciduad_id" required onChange={this.props.handleInputChangeCity}>
                    <option value="">{t('dashboard.question.botooms.select')}</option>                                                    
                </select>
            )
        }
    }

    centro = () => {
        const { t } = this.props;
        if (this.props.info.centro && this.props.info.objUser.centro) {
            return (
                <div className="col-md-8">
                    <h3 className="info_socio">{this.props.info.centro}</h3>
                </div>
            )
        } else {
            return (
                <div className="col-md-12">
                        <label htmlFor="centro">{t('dashboard.question.data.place')}<i>*</i></label>
                        {this.optionsCenters()}
                    </div>
            )
        }
    }

    optionsCenters = () => {
        const { t } = this.props;
        if (Object.keys(this.props.info.objCenters).length > 0) {
            return (
                <select value={this.props.info.centro_id} className="form-control" id="centro_id" name="centro_id" required onChange={this.props.handleInputChangeCenter}>
                    <option disabled value="">{t('dashboard.question.botooms.select')}</option>    
                    {Object.values(this.props.info.objCenters).map((centro, i) => (
                        <option key={i} value={centro.id}>{centro.centro}</option>
                    ))}
                </select>
            )
        } else {
            return (
                <select className="form-control" id="centro_id" name="centro_id" required onChange={this.props.handleInputChangeCenter}>
                    <option defaultValue value="">{t('dashboard.question.botooms.select')}</option>                                                    
                </select>
            )
        }
    }

    // Boton para validar inofrmacion de usuario
    formButton = () =>{
        const { t } = this.props;
        disabled = (this.props.info.centro_id > 0) ? false : true
        return (
            <div className="panel-body col-xs-12" style={{textAlign: "center"}}>
                <button className="btn_form" type="submit" onClick={this.handleClickContinue} readOnly={disabled}> {this.state.sendPost ? t('dashboard.question.botooms.send') : t('dashboard.question.botooms.continue')}</button>
                <img id="loadingImg" className={this.state.sendPost ? "" : "hidden"} src={spinner}/>
            </div> 
        )
    }

   
}

export default translate('common')(FormUser);
const styleBtn = {background: 'linear-gradient(32deg, rgba(255,255,255,1) 0%, rgba(104,235,75,1) 1%, rgba(69,194,228,1) 100%)', border: '0px'}


// WEBPACK FOOTER //
// ./src/guest/improvement/FormUser.js